// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Checkmark-module--cds--assistive-text--2bbe8";
export var cdsVisuallyHidden = "Checkmark-module--cds--visually-hidden--a8f82";
export var drawStroke = "Checkmark-module--drawStroke--c88fc";
export var hideFeedback = "Checkmark-module--hide-feedback--1a7b3";
export var path = "Checkmark-module--path--0bd5a";
export var showFeedback = "Checkmark-module--show-feedback--5a874";
export var skeleton = "Checkmark-module--skeleton--c5b28";
export var svg = "Checkmark-module--svg--56a9c";